__turbopack_context__.v({
  "center_button": "styles-module-scss-module__CqksPa__center_button",
});
